import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BsPencilSquare } from 'react-icons/bs';
import { ImCalendar } from 'react-icons/im';
import { Link } from 'gatsby';
import { clearUrl } from '../../utils/helperFunctions';
import { useLanguage } from '../../locales';
import {
  Wrapper,
  LinkImageContainer,
  PostContent,
  PostTitle,
  PostDetailItem,
  PostDetails,
} from './styles/PostCard.styles';
import Moment from 'react-moment';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
const PostCard = ({ post }) => {
  const { lang } = useLanguage();

  return (
    <Wrapper>
      <LinkImageContainer
        to={`/posts/${clearUrl(post.slug)}`}
        className="image-container"
        onClick={() => {
          trackCustomEvent({
            category: 'post',
            action: 'click',
            label: post.slug,
          });
        }}
      >
        <LazyLoadImage
          src={`https:${post?.image?.fixed?.src}`}
          alt={`https:${post?.image?.fixed?.src}`}
          effect="blur"
        />
      </LinkImageContainer>
      <PostContent>
        <PostTitle>
          <Link
            to={`/posts/${clearUrl(post.slug)}`}
            title={post[`title_${lang}`]}
            onClick={() => {
              trackCustomEvent({
                category: 'post',
                action: 'click',
                label: post.slug,
              });
            }}
          >
            {post[`title_${lang}`].split(' ').length > 15
              ? post[`title_${lang}`].split(' ').slice(0, 15).join(' ') + ' ...'
              : post[`title_${lang}`]}
          </Link>
        </PostTitle>
        <PostDetails>
          <PostDetailItem>
            <BsPencilSquare />
            <span>{post.author.slice(0, 25)}</span>
          </PostDetailItem>
          <PostDetailItem>
            <ImCalendar />
            <Moment format="LL" locale={lang}>
              {new Date(post.updatedAt)}
            </Moment>
          </PostDetailItem>
        </PostDetails>
      </PostContent>
    </Wrapper>
  );
};

export default PostCard;
